<template>
  <div class="no-data">
    <p>暂无商品</p>
  </div>
</template>

<script>
export default {
  name: 'noData'
}
</script>

<style lang="less" scoped>
.no-data {
  text-align: center;
  padding: 1rem 0;
  font-size: @fz32;
}
</style>
